import React from 'react';
import propTypes from 'prop-types';
;;
import { Button, Columns, Column, ModalCardBody, ModalCardHeader, ModalCardTitle, ModalCard, ModalBackground, Modal, Control } from 'src/ui/mui-ui-kit';;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FadeInDiv, AnimatedCard } from 'src/ui/logic';
import { usePoseWithBulma } from 'src/ui/hooks';
import { Form, Field } from 'react-final-form';
import { UiFileUploaderAdapter, UiSpacer, UiInputAdapter } from 'src/ui';
import { composeValidators, required, date } from 'src/ui/validations';
import { DATE_MASK } from '../../ui/const';
export function AddDocumentModal({
  isActive,
  onSubmit,
  onCancel,
  expirationOnUpload,
  needsApproval,
  isCustom,
}) {
  const [currentPose, isModalVisible, onPoseComplete] = usePoseWithBulma(
    isActive
  );
  const { format, startOfDay } = require('date-fns');
  const today = startOfDay(new Date());

  const handleSubmit = e => {
    const { document, expirationDate } = e;
    let { uploadDate } = e;
    // eslint-disable-next-line no-unused-expressions
    !uploadDate
      ? (uploadDate = format(today, 'YYYY-MM-DD'))
      : (uploadDate = format(uploadDate, 'YYYY-MM-DD'));
    onSubmit(document, expirationDate, uploadDate);
    onCancel();
  };
  return (
    <Modal isActive={isModalVisible} className="confirm-changes-modal">
      <ModalBackground
        tag={FadeInDiv}
        pose={currentPose}
        onPoseComplete={onPoseComplete}
      />
      <ModalCard tag={AnimatedCard} pose={currentPose}>
        <ModalCardHeader>
          <ModalCardTitle
            tag="h5"
            // hasTextAlign="centered"
            className="has-text-weight-semibold columns is-vcentered"
          >
            <Column isSize="narrow" tag="span">
              <span className="icon is-medium has-icon-gradient-bright">
                <FontAwesomeIcon icon={['fal', 'file-upload']} size="lg" />
              </span>
            </Column>
            <Column tag="span" hasTextColor="primary" isPaddingless>
              Upload Document
            </Column>
          </ModalCardTitle>
        </ModalCardHeader>
        <ModalCardBody hasTextAlign="centered">
          <Form
            onSubmit={handleSubmit}
            render={({ handleSubmit }) => (
              <>
                <Columns isMultiline isCentered>
                  <Column isSize="full">
                    <Field
                      component={UiFileUploaderAdapter}
                      name="document"
                      id="document"
                      label="Document Upload"
                      type="file"
                      required
                      validate={composeValidators('Document Upload', required)}
                    />
                  </Column>
                  <Column isSize="1/2">
                    <UiSpacer />
                    <UiSpacer />
                    {expirationOnUpload && (
                      <Field
                        component={UiInputAdapter}
                        name="expirationDate"
                        id="expirationDate"
                        label="Expiration Date"
                        mask={DATE_MASK}
                        required
                        hasIcons="right"
                        validate={composeValidators(
                          'Expiration Date',
                          required,
                          date
                        )}
                        renderIcons={() => [
                          <span className="icon is-right" key="right-icon">
                            <FontAwesomeIcon icon={['fal', 'calendar-alt']} />
                          </span>,
                        ]}
                      />
                    )}
                    {!needsApproval && isCustom && (
                      <Field
                        component={UiInputAdapter}
                        name="uploadDate"
                        id="uploadDate"
                        label="Upload Date"
                        mask={DATE_MASK}
                        defaultValue={format(today, 'MM-DD-YYYY')}
                        required
                        hasIcons="right"
                        validate={composeValidators(
                          'Upload Date',
                          required,
                          date
                        )}
                        renderIcons={() => [
                          <span className="icon is-right" key="right-icon">
                            <FontAwesomeIcon icon={['fal', 'calendar-alt']} />
                          </span>,
                        ]}
                      />
                    )}
                  </Column>
                </Columns>

                <div className="buttons is-centered">
                  <Button
                    isOutlined
                    className="is-long"
                    hasTextColor="info"
                    onClick={onCancel}
                  >
                    Cancel
                  </Button>
                  <Control>
                    <Button
                      isOutlined
                      className="is-long"
                      isColor="gradient-bright"
                      onClick={e => handleSubmit(e)}
                    >
                      Submit
                    </Button>
                  </Control>
                </div>
              </>
            )}
          />
        </ModalCardBody>
      </ModalCard>
    </Modal>
  );
}

AddDocumentModal.defaultProps = {
  needsApproval: false,
  isCustom: false,
};

AddDocumentModal.propTypes = {
  isActive: propTypes.bool.isRequired,
  onSubmit: propTypes.func.isRequired,
  onCancel: propTypes.func.isRequired,
  expirationOnUpload: propTypes.bool.isRequired,
  needsApproval: propTypes.bool,
  isCustom: propTypes.bool,
};
